import { SolicitacaoChatMessageTypeEnum, ISolicitacaoChatMessage } from '@/types/interfaces/solicitacao-chat/solicitacao-chat-message.interface'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import { getUser } from '@/utils/common'
import { User } from '@/types/_'
import SolicitacaoStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoStore'
import SolicitacaoPendenciaStore from '../SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import ChatAgendamentoModule from './chat-agendamento-pendencia.module'
import ChatAgendamentoPendenciaStore from './store/chat-agendamento-pendencia-store'

@Component({
  components: ChatAgendamentoModule.components,
})
export default class ComponentChatAgendamentoPendencia extends Vue {
  canShowRightPanel = false
  replyLoading = false

  public user: User = { ...getUser() }

  mounted() {
    // Check can show right panel when starts based in screen width
    if (window.screen.availWidth > 600) {
      this.canShowRightPanel = true
    }
  }

  send(value: string) {
    const message = {
      tipo: SolicitacaoChatMessageTypeEnum.texto,
      texto: value,
    } as ISolicitacaoChatMessage

    this.chatStore.sendMessage(message)
  }

  sendAttachment(data: File) {
    this.chatStore.sendAttachment(data)
  }

  get attachmentLoading() {
    return this.chatStore.attachmentLoading
  }

  set attachmentLoading(value: boolean) {
    this.chatStore.setAttachmentLoading(value)
  }

  async reply() {
    this.replyLoading = true

    try {
      await this.chatStore.reply()
      this.close()
      this.$emit('pendenciaRespondida')
    // eslint-disable-next-line no-empty
    } catch (err) { }

    this.replyLoading = false
  }

  ga(event: string, action: string) {
    this.$ga.event(event, action, this.user.profile.email)
  }

  async close() {
    await this.chatStore.closeChatModal()
  }

  getMessageType(data: ISolicitacaoChatMessage) {
    if (data.tipoMensagem) {
      const messageType = data.tipoMensagem.key

      if (
        messageType === SolicitacaoChatMessageTypeEnum.texto
        || messageType === SolicitacaoChatMessageTypeEnum.anexo
      ) {
        return 'message'
      }
    }

    return 'marker'
  }

  getMessageSide(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.user.profile.sub
    if (data.usuarioId === loggedUserId) {
      return 'right'
    }

    return 'left'
  }

  getCanShowFooter(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.user.profile.sub
    const messageType = this.getMessageType(data)

    if (
      data.usuarioId === loggedUserId
      && messageType !== 'marker'
    ) {
      return true
    }

    return false
  }

  getSenderName(data: ISolicitacaoChatMessage) {
    const loggedUserId = this.user.profile.sub
    const messageType = this.getMessageType(data)

    if (
      data.usuarioId !== loggedUserId
      && messageType !== 'marker'
    ) {
      return data.usuarioNome
    }

    return ''
  }

  toggleRightPanel() {
    this.canShowRightPanel = !this.canShowRightPanel
  }

  formatDateForDay(dateString: string) {
    if (dateString) {
      const date = new Date(dateString)
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      let completedDate: string
      if (date.toLocaleDateString() === new Date().toLocaleDateString()) {
        completedDate = 'Hoje'
      } else {
        completedDate = date.toLocaleDateString()
      }

      return `${completedDate} às ${hours}:${minutes}`
    }

    return ''
  }

  editSolicitation() {
    const { agendamentoMedico } = this.solicitacaoPendenciaStore
    const { id, hospitalId, medicoSolicitanteId, nomeMedico } = agendamentoMedico

    // const link = document.createElement('a')
    // link.href = `/solicitacao-cirurgia/${id}/${hospitalId}/${medicoSolicitanteId}/${nomeMedico}`
    // link.target = '_blank'
    // link.click()

    this.ga('agendamento-medico', 'editar-solicitacao')

    const route = {
      name: 'SolicitacaoCirurgia',
      view: 'solicitacao-cirurgia',
      path: '/solicitacao-cirurgia/:solicitacaoId?/:hospitalId?/:medicoId?/:medico?',
      params: {
        hospitalId,
        medicoId: medicoSolicitanteId,
        medico: nomeMedico,
        solicitacaoId: id,
      },
    }

    this.close()
    this.solicitacaoStore.setShowModalGerenciar(false)

    this.$router.push(route).catch(() => {})
  }

  get chatStore() {
    return getModule(ChatAgendamentoPendenciaStore, this.$store)
  }

  get solicitacaoPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get solicitacaoStore() {
    return getModule(SolicitacaoStore, this.$store)
  }

  // Permissions

  get canEditSolicitation() {
    return this.solicitacaoPendenciaStore.agendamentoMedico.acoes.editar
  }
}
